<template>
    <div class="divMessaggio" :class="$store.state.MessaggioGlobale.alertClass" v-if="$store.state.MessaggioGlobale.mostraMessaggio">
        <font-awesome-icon :icon="$store.state.MessaggioGlobale.alertIcon" v-if="$store.state.MessaggioGlobale.alertIconSpin" spin />
        <!-- <font-awesome-icon :icon="['fa-solid','fa-spinner', 'spin']" v-if="$store.state.MessaggioGlobale.alertIconSpin" /> -->
        <font-awesome-icon :icon="$store.state.MessaggioGlobale.alertIcon" v-else  />
        &nbsp;
        {{ProcessaTestoMessaggio()}}
    </div>
</template>

<script>


export default {
 name: "MessaggioGlobale",   
 props: {
   
 },
 data: function () {
    return {
      
    }
 },
 methods: {
    ProcessaTestoMessaggio() {
        let msg = '';
        for(let i=0; i<this.$store.state.MessaggioGlobale.alertMessaggio.length; i++) {
            msg += this.$store.state.MessaggioGlobale.alertMessaggio[i] + " ";
        }
        return msg;
    }  
 },
 watch: {
   
 },
 mounted: function() {
    
    
 }
 
}

</script>

<style scoped>
    .divMessaggio {
        margin-top:15px;
        line-height: 13px;
        font-weight: 0;
        
    }

</style>
